export default __webpack_public_path__ + "static/media/img-notice-bg.4e3a43d0.svg";